import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';

import { useLayoutStore } from '../../store/layoutStore';

export function useMainContentTabsShallow() {
  const {
    tabs,
    activeTabId,
    closeTab,
    setActiveTab,
    togglePinTab,
    reorderTabs,
  } = useLayoutStore(
    useShallow((state) => ({
      tabs: state.mainContentTabs,
      activeTabId: state.activeMainContentTabId,
      closeTab: state.closeMainContentTab,
      setActiveTab: state.setActiveMainContentTab,
      togglePinTab: state.togglePinTab,
      reorderTabs: state.reorderMainContentTabs,
    })),
  );

  const tabsWithActiveState = useMemo(
    () => tabs.map((tab) => ({ ...tab, isActive: tab.id === activeTabId })),
    [tabs, activeTabId],
  );
  const activeTab = useMemo(
    () => tabsWithActiveState.find((tab) => tab.isActive),
    [tabsWithActiveState],
  );

  return {
    tabs: tabsWithActiveState,
    activeTab,
    closeTab,
    setActiveTab,
    togglePinTab,
    reorderTabs,
  };
}
